<template>
  <v-container grid-list-xl class="pa-0">
    <v-row wrap>
      <!-- <v-col cols="12" align="left">
        <m-alert :show="!addData" title="Informasi" info="Pendaftaran telah ditutup." closable></m-alert>
      </v-col>-->
      <v-col cols="12" align="right">
        <m-button v-if="addData" fab class="mb-3" right text icon="mdi-plus" action="add" @add="add"></m-button>
        <m-button
          v-if="selectedItems.length > 0"
          class="mb-3"
          right
          text
          fab
          action="delete"
          @delete="unenrolled"
          icon="mdi-delete"
          color="error"
          @add="add"
        ></m-button>
      </v-col>
      <v-col cols="12">
        <v-data-table
          v-model="selectedItems"
          :headers="headers"
          :items="items"
          :items-per-page="15"
          item-key="id"
          :show-select="addData"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td v-show="addData">
                  <v-checkbox v-model="selectedItems" :value="item" style="margin:0px;padding:0px" hide-details />
                </td>
                <td>
                  <p class="subtitle-1 my-0 py-0">
                    {{ pVal(item, "name") }}

                    <v-chip v-if="item.is_utama" small color="success">Utama</v-chip>
                  </p>
                  <p class="grey--text">{{ pVal(item, "email") }}</p>
                </td>

                <td>
                  <ul>
                    <li class="subtitle-1 primary--text my-0 py-0" v-for="bs in item.mapel" :key="bs.index">
                      {{ bs.keterangan }}
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li class="subtitle-1 primary--text my-0 py-0" v-for="jg in item.jenjang" :key="jg.index">
                      {{ jg.keterangan }}
                    </li>
                  </ul>
                </td>
                <td>
                  <div v-if="item.kecamatan" class="mt-2">
                    <span class="primary--text"> {{ pVal(item.kecamatan.kota.propinsi, "keterangan") }} </span>,
                    <span class="teal--text">{{ pVal(item.kecamatan.kota, "keterangan") }}</span>
                    <p class="orange--text">Kec. {{ pVal(item.kecamatan, "keterangan") }}</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import ChangeDlg from "../../enroll/components/Form.vue";
export default {
  components: {
    ChangeDlg
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    tipe: {
      type: Number,
      default: 5
    },
    addData: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      textSearch: null,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      pagging: {},
      page_key: 0,
      totalPagination: [],
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o)
        }
      ]
    };
  },
  computed: {
    headers() {
      if (this.tipe == 7 || this.tipe == 8 || this.tipe == 9 || this.tipe == 6) {
        if (this.addData) {
          const a = [
            { text: "Identitas", align: "left", value: "", sortable: false },
            { text: "Bidang Studi", align: "left", value: "", sortable: false },
            { text: "Jenjang", align: "left", value: "", sortable: false },
            { text: "Wilayah", align: "left", value: "", sortable: false }
          ];
          return a;
        } else {
          const a = [
            { text: "Identitas", align: "left", value: "", sortable: false },
            { text: "Bidang Studi", align: "left", value: "", sortable: false },
            { text: "Jenjang", align: "left", value: "", sortable: false },
            { text: "Wilayah", align: "left", value: "", sortable: false }
          ];
          return a;
        }
      } else {
        const b = [
          { text: "Identitas", align: "left", value: "", sortable: false },
          { text: "Bidang Studi", align: "left", value: "", sortable: false },
          { text: "Wilayah", align: "left", value: "", sortable: false }
        ];
        return b;
      }
    }
  },
  methods: {
    filter(data) {
      this.filteredData = data;
      this.load();
    },
    detail(item) {
      this.$refs.detailDlg.open(item);
    },
    add() {
      this.$refs.dlg.open(this.item, this.tipe).then(() => {
        this.$emit("load");
        this.selectedItems = [];
      });
    },
    edit(item) {
      this.$refs.dlg.open(item, this.tipe).then(() => {
        // this.load();
      });
    },
    unenrolled() {
      var daftarPengguna = [];
      this.selectedItems.forEach(item => {
        var obj = {
          user_id: item.id,
          grup_id: this.tipe
        };
        daftarPengguna.push(obj);
      });

      this.$confirm(
        `Apakah Anda yakin akan mengeluarkan pengguna terpilih dari kelas ?<br>
        <div class="mt-2 title grow text-center">

        </div>`
      )
        .then(() =>
          this.$store.dispatch("enroll/unenrolled", {
            instansi_id: this.instansi_id,
            diklat_id: this.diklat_id,
            kelas_id: this.$route.params.kelas_id,
            obj: daftarPengguna
          })
        )
        .then(res => {
          this.selectedItems = [];
          if (res.status == 201) {
            return this.$info("Pengguna terpilih berhasil dikeluarkan dari kelas");
          }
        })
        .then(() => this.$emit("load"))
        .catch(e => e);
    },
    setUtama(item) {
      var obj = {
        user_id: item.id,
        grup_id: this.tipe
      };

      var peran = this.tipe == 2 ? "admin LMS" : this.tipe == 3 ? "Fasil Dosen" : "Fasil GP";

      this.$confirm(
        `Apakah Anda yakin akan menjadikan pengguna terpilih menjadi ` +
          peran +
          ` Utama ?<br>
        <div class="mt-2 title grow text-center">

        </div>`
      )
        .then(() =>
          this.$store.dispatch("enroll/setUtama", {
            instansi_id: this.instansi_id,
            diklat_id: this.diklat_id,
            kelas_id: this.$route.params.kelas_id,
            obj: obj
          })
        )
        .then(() => this.$emit("load"))
        .catch(e => e);
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    items() {
      var selected = this.selectedItems;
      this.selectedItems = [];

      setTimeout(function() {
        return (this.selectedItems = selected);
      }, 5);

      this.current_page = this.page ? this.page.current_page : 0;
    }
  }
};
</script>
